import './index.css';
import AppRouter from './components/AppRouter';
import {AuthProvider} from './contexts/AuthContext';
function App(props) {
  return (
    <AuthProvider>
        <AppRouter />
    </AuthProvider>
  );
}

export default App;
